import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import UserBreadcrumb from "@/components/common/UserBreadcrumb.vue";
import CreateDownlineFormModal from "@/components/modules/account/CreateDownlineFormModal.vue";
import UpdateDownlineFormModal from "@/components/modules/account/UpdateDownlineFormModal.vue";
import GameSettingFormModal from "@/components/modules/account/GameSettingFormModal.vue";
import MobileSettingFormModal from "@/components/modules/account/MobileSettingFormModal.vue";
import { formatDollar } from "@/helpers/formatDollar";
import { sortBy, startCase } from "lodash";
import AccountSelectModal from "@/components/modules/account/AccountSelectModal.vue";
import AccountSelectSearch from "@/components/modules/account/AccountSelectSearch.vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router/composables";
import { useQuery } from "@vue/apollo-composable";
import { queries } from "@/apollo";
import { stringRouteQuery } from "@/helpers/stringRouteQuery";
import ChangePasswordFormModal from "@/components/modules/account/ChangePasswordFormModal.vue";
import CopySettingModal from "../../modules/account/CopySettingModal.vue";
import { useRootStore } from "@/store/pinia";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'Downlines',
  setup(__props) {

const route = useRoute();

const userId = computed(() => stringRouteQuery(route.query.userId));

const me = useRootStore().account;

const { $t } = useTranslation();


const { result, loading, refetch } = useQuery<{ user: User }>(
  queries.userWithDownlinesAndCredits,
  { userId },
  { fetchPolicy: "cache-and-network" }
);

const selectedUser = ref<User | null>(null);

const showAccountSelectionModal = ref(false);
const showCreateDownlineModal = ref(false);
const showGameSettingModal = ref(false);
const showMobileSettingModal = ref(false);
const showUpdateDownlineModal = ref(false);
const showChangePasswordModal = ref(false);
const showCopyModal = ref(false);

const downlinesSorted = computed(() => {
  return sortBy(result.value?.user?.downlines, (u) => u.userId);
});

function refetchAll() {
  refetch();
}

function selectUser(userId: User["userId"]) {
  const foundUser = result.value?.user?.downlines.find(
    (dl) => dl.userId === userId
  );
  if (foundUser) {
    selectedUser.value = foundUser;
  } else {
    throw new Error("Invalid user selected.");
  }
}

return { __sfc: true,route, userId, me, $t, result, loading, refetch, selectedUser, showAccountSelectionModal, showCreateDownlineModal, showGameSettingModal, showMobileSettingModal, showUpdateDownlineModal, showChangePasswordModal, showCopyModal, downlinesSorted, refetchAll, selectUser, UserBreadcrumb, CreateDownlineFormModal, UpdateDownlineFormModal, GameSettingFormModal, MobileSettingFormModal, formatDollar, startCase, AccountSelectModal, AccountSelectSearch, ChangePasswordFormModal, CopySettingModal }
}

})